/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_External_IdInputs */

const cs_settings_calendar_external_id = /** @type {(inputs: Settings_Calendar_External_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID kalendáře (volitelné)`)
};

const en_settings_calendar_external_id = /** @type {(inputs: Settings_Calendar_External_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendar id (optional)`)
};

/**
* | output |
* | --- |
* | "Calendar id (optional)" |
*
* @param {Settings_Calendar_External_IdInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_external_id = /** @type {((inputs?: Settings_Calendar_External_IdInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_External_IdInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_external_id(inputs)
	return cs_settings_calendar_external_id(inputs)
});